

//Channel SPBU
const DiscoverySPBU = () => import(/* webpackChunkName: "SPBU" */ '../views/Discovery/SPBU')

//Result Page		
const ResultPageSPBU = () => import(/* webpackChunkName: "ResultPageSPBU" */ '../views/ResultPage/SPBU')

//Detail page		
const DetailSpbuV2 = () => import(/* webpackChunkName: "DetailSpbuV2" */ '../views/DetailPage/SPBU')

const spbuRouter = [
    // {
    //     path: '/spbu',
    //     name: 'discoveryspbu',
    //     component: DiscoverySPBU
    // },
    {
        path: '/result/:city_name?/spbu',
        name: 'resultspbu',
        component: ResultPageSPBU
    },
    {
        path: '/spbu/detail-page/:id',
        name: 'detailspbuv2',
        component: DetailSpbuV2
    }
]

export default spbuRouter;